import styled from "@emotion/styled";
import { IStyledComponentProps } from "../../theme/theme.types";

const LoadingOverlayContainer = styled.div<IStyledComponentProps>`
  &.loading-overlay {
    background-color: rgba(0, 0, 0, 0.75);
    opacity: 0;
    position: absolute;
    top: 75px;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 500;
  }
`;

const LoadingIconContainer = styled.div<IStyledComponentProps>`
  &.loading-icon-container {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    width: 100%;

    .svg-container {
      background-color: #ffffff;
      width: 60px;
      height: 60px;
      border-radius: 50%;
      right: 6px;
      position: relative;
      margin-top: -75px;
      opacity: 0;
      transform: scale(0);
      svg {
        width: 60px;
        height: 60px;
        position: absolute;
        opacity: 0;
      }
    }
    .loading-message-container {
      margin: 8px auto;
      text-align: center;
      width: 168px;
      h1 {
        color: white;
        font-size: 16px;
        opacity: 0;
        position: absolute;
      }
    }
  }
`;

export default { LoadingOverlayContainer, LoadingIconContainer };
